import React from 'react';

export default function ToogleButton({
    className,
    activeCssClass = 'active',
    inActiveCssClass = '',
    svg,
    name,
    toogleOn,
    handler,
    disabled,
    onClick,
    children,
    ...rest
}) {
    return (
        <button
            onClick={() => (onClick ? onClick() : handler ? handler(!toogleOn) : null)}
            className={`${className} ${toogleOn ? activeCssClass || '' : inActiveCssClass || ''} ${disabled ? 'disabled' : ''} ${
                !name ? 'no-name' : ''
            }`}
            disabled={disabled}
            style={{ whiteSpace: 'nowrap' }}
            {...rest}
        >
            {!!svg && svg}
            {name}
            {children}
        </button>
    );
}
